import Vue from 'vue';
import client from '@/apis/client';

const localize = (item, key) => {
  const locale = Vue.$cookies.get('locale') || 'th_TH';

  if (locale === 'en_US' && item[`${key}_en`]) {
    return item[`${key}_en`];
  }

  return item[key];
};

export const getContact = async () => {
  let { data: { data } } = await client.get('/contact');

  if (typeof data === 'object') {
    data = {
      ...data,
      address_localized: localize(data, 'address'),
    };
  }

  return data;
};

export const saveContact = async (data) => {
  await client.post('/contact', data);
};
